import { render, staticRenderFns } from "./inverter-create.vue?vue&type=template&id=6a08e18c"
import script from "./inverter-create.vue?vue&type=script&lang=js"
export * from "./inverter-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports